import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useQuizQuestions(data = {}) {
  const { enabled = false, quizID, courseID, chapterID, configs } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getQuizQuestions() {
    return privateFetch
      .get(
        `/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions`,
        configs
      )
      .then((res) => res.data);
  }

  return useQuery(['quiz-questions', quizID, { data }], getQuizQuestions, {
    enabled,
    keepPreviousData: true,
  });
}

export default useQuizQuestions;
